<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  modelValue: string | number | undefined;
  options: Array<{ label: string; value: string | number }>;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string | number | undefined];
}>();

const value = computed({
  get: () => props.modelValue,
  set: (val: string | number | undefined) => emit('update:modelValue', val),
});
</script>

<template>
  <div class="card-radio-container">
    <a-radio-group v-model:value="value" class="card-radio">
      <div
        class="card"
        :class="{ selected: value === option.value }"
        v-for="option in options"
        :key="option.value"
        @click="value = option.value"
      >
        <span class="label">{{ option.label }}</span>
        <span class="radio-container">
          <a-radio :value="option.value" class="radio-right" />
        </span>
      </div>
    </a-radio-group>
  </div>
</template>

<style lang="less" scoped>
.card-radio-container {
  margin: 10px 0;
}

.card {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: @color-primary;
  background-color: @color-background-light;
  cursor: pointer;
  border: 1px solid @color-primary;
  border-bottom: none;
}

.card-radio-container .card:first-child {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.card-radio-container .card:last-child {
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  border-bottom: 1px solid @color-primary;
}

.card-radio {
  display: flex;
  flex-direction: column;
}

.card.selected {
  background-color: @color-background-light; //--Change to emphasize selected option--
}

:deep(.ant-radio-inner) {
  border-width: 2px !important;
  border-color: @color-primary !important;
}

:deep(.ant-radio-checked .ant-radio-inner::after) {
  background-color: @color-primary !important;
}

.radio-container {
  text-align: end;
}

.label {
  font-size: 1rem;
  font-weight: @font-weight-medium;
  flex: 1 1 90%;
  text-align: center;
}

.radio-right :deep(.ant-radio) {
  transform: scale(1.05);
}
</style>
